import { Route } from "@faire/web-api/Route";
import { props as faireMarketsRouteProps } from "@faire/web-api/routes/markets";
import { props as marketBrandDirectoryRouteProps } from "@faire/web-api/routes/markets/brand-directory/event_type";
import { props as preShowPageProps } from "@faire/web-api/routes/markets/event_type/all-specials";
import { Switch } from "@faire/web/ui/routing/Switch";
import { observer } from "mobx-react";
import React, { Suspense } from "react";
import { Redirect } from "react-router-dom";

import { MarketBrandDirectoryRouter } from "@faire/retailer/features/FaireMarkets/MarketBrandDirectoryRouter";
import { MarketPreshowRouter } from "@faire/retailer/features/FaireMarkets/MarketPreshowRouter";
import { LazyFaireMarketsPage } from "@faire/retailer/features/FaireMarkets/MarketsPage/LazyFaireMarketsPage";
import { home } from "@faire/retailer/paths";
import { PreShowRouter } from "@faire/retailer/views/promotional-events/pre-show/PreShowRouter";

const MarketRouterBase: React.FunctionComponent = () => (
  <Suspense fallback={null}>
    <Switch>
      <Route
        {...faireMarketsRouteProps}
        component={LazyFaireMarketsPage}
        exact
      />
      <MarketPreshowRouter />
      <Route {...preShowPageProps} component={PreShowRouter} />
      <Route
        {...marketBrandDirectoryRouteProps}
        component={MarketBrandDirectoryRouter}
      />
      <Redirect to={home()} />
    </Switch>
  </Suspense>
);

export const MarketRouter = observer(MarketRouterBase);
